import React, { useEffect, useState } from "react";
import { Crud_Catalogos, Crud_error } from '../../../herramientas/Crud_Catalogos';
import { timeToDateFill } from "../../../herramientas/DateFormat";
import { TablePageable } from "../../../Helpers";
import Select from "react-select";



const WhatsAppGruposClientesCorredores =({cliente, stor, plataforma})=> {

  
  const [clientesWhatsappGrupos, setContactosClientesWhatsappGrupos]= useState([]);
  const [whatsappGrupos, setWhatsappGrupos]= useState([]);
  const [whatsappGrupo, setWhatsappGrupo]= useState([]);
  const [corredores, setCorredores]= useState([]);
  const [editando, setEditando]= useState(null);
  const [modalAgregar, setModalAgregar]= useState(false);
  const [corredorModal, setCorredorModal]= useState({ value: 0, label: "Seleccione un corredor" });
  const [grupoSeleccionado, setGrupoSeleccionado]= useState(null);

  useEffect(() => {
        if(plataforma && plataforma.id){
          getfuntion("get", "", "", "corredores/plataforma/" + plataforma.id, "corredores");
        }
        if(cliente && cliente.id){
          getfuntion("get", "", "", "clientes_corredores_whatsapp_grupos/" + cliente.id, "clientes_whatsapp_grupos");
        }
    }, []);


 const getfuntion = (metodo = "get", obj = [], id = "", catalogo = "personas", stateVar = "personas", hiddenModl = "") => {
    console.log("entroooo")
    console.log(catalogo)
    console.log(obj)
    return Crud_Catalogos(catalogo, "plataformas", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
      /**
       * filtro de variables
       */
      console.log(metodo)
      switch (metodo) {
        case "get":
          if (stateVar === "clientes_whatsapp_grupos") {
            let clientesWhatsappGruposTemp= [];
            for(let c of returnVal){
              c.fecha= timeToDateFill(c.fecha);
              clientesWhatsappGruposTemp.push(c);
            }
            setContactosClientesWhatsappGrupos(clientesWhatsappGruposTemp);
          }
          if (stateVar === "whatsapp_grupos") {
            let whatsappGruposTemp= [];
            for(let c of returnVal){
              c.fecha= timeToDateFill(c.fecha);
              // Filtrar grupos ya asignados
              const yaAsignado = clientesWhatsappGrupos.some(cg => cg.idWhatsappGrupo === c.id);
              if (!yaAsignado) {
                whatsappGruposTemp.push(c);
              }
            }
            setWhatsappGrupos(whatsappGruposTemp);
          }
          if (stateVar === "corredores") {
            let corredoresTemp = [];
            for (let item of returnVal) {
              corredoresTemp.push({
                value: item.id,
                label: item.nombre,
                data: item,
              });
            }
            setCorredores(corredoresTemp);
          }
          break;
        case "post":
          if (stateVar === "clientes_whatsapp_grupos") {
            getClientesWhatsAppGrupos();
            setModalAgregar(false);
            setCorredorModal({ value: 0, label: "Seleccione un corredor" });
            setGrupoSeleccionado(null);
          }
          break;
        case "put":
          if (stateVar === "clientes_whatsapp_grupos") {
            getClientesWhatsAppGrupos();
            setEditando(null);
          }
          break;
        case "delete":
          if (stateVar === "clientes_whatsapp_grupos") {
            getClientesWhatsAppGrupos();
          }
          break;
        default:
          break;
      }
    }).catch(err => { console.log(err) });
  }

  const getClientesWhatsAppGrupos =()=>{
    getfuntion("get", "", "", "clientes_corredores_whatsapp_grupos/" + cliente.id, "clientes_whatsapp_grupos");
  }

  const actualizarGrupo = (elemento, campo, valor) => {
    const cwt = {
      idCliente: cliente.id,
      idWhatsappGrupo: elemento.id,
      idCorredor: elemento.idCorredor,
      [campo]: valor,
      fecha: elemento.fecha,
    };
    getfuntion("put", cwt, "", "clientes_corredores_whatsapp_grupos", "clientes_whatsapp_grupos");
  };

  const guardarNuevoGrupo = () => {
    if (!grupoSeleccionado || corredorModal.value === 0) {
      alert("Debe seleccionar un corredor y un grupo");
      return;
    }
    const cwt = {
      idCliente: cliente.id,
      idCorredor: corredorModal.data.id,
      idWhatsappGrupo: grupoSeleccionado.id,
      estatus: true,
    };
    getfuntion("post", cwt, "", "clientes_corredores_whatsapp_grupos", "clientes_whatsapp_grupos");
  };

  return (
    <div className="mt-1">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <i className="fa fa-whatsapp" style={{ fontSize: "22px", color: "#25D366" }}></i>
          <h5 style={{ margin: 0, fontWeight: 600 }}>Grupos de WhatsApp asignados</h5>
        </div>
        <button
          className="btn btn-sm btn-success"
          style={{ display: "flex", alignItems: "center", gap: "5px" }}
          onClick={() => {
            setModalAgregar(true);
            getfuntion("get", "", "", "whatsapp_grupos/plataforma/" + plataforma.id, "whatsapp_grupos");
          }}
        >
          <i className="fa fa-plus"></i> Agregar grupo
        </button>
      </div>
      <div>
        <TablePageable
          lista= { clientesWhatsappGrupos }
          columnas={
            [
              { columna: "whatsappGrupos.nombreGrupo", label:"Grupo de Whatsapp",
                form: (e) => e.whatsappGrupos?.nombreGrupo || ""
              },
              { columna: "corredor.nombre", label:"Corredor" },

              { columna: "estatusEditable", label:"Estatus",
                form: (e) => 
                  <div onClick={(event) => event.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={e.estatus === 1 || e.estatus === true}
                      onChange={(event) => {
                        const cwt = {
                          idCliente: cliente.id,
                          idCorredor: e.corredor?.id,
                          idWhatsappGrupo: e.whatsappGrupos?.id,
                          estatus: event.target.checked,
                        };
                        getfuntion("put", cwt, "", "clientes_corredores_whatsapp_grupos", "clientes_whatsapp_grupos");
                      }}
                    />
                  </div>
              },
              { columna: "fecha", label:"Fecha" },
            ]
          }
          id= "id"
          selected={(e)=> setWhatsappGrupo(e)}
        />
      </div>

      {/* Modal para agregar nuevo grupo */}
      {modalAgregar && (
        <div
          style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(3px)" }}
          onClick={() => setModalAgregar(false)}
        >
          <div
            style={{ width: "680px", maxWidth: "95vw", maxHeight: "85vh", backgroundColor: "#fff", borderRadius: "12px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", display: "flex", flexDirection: "column", overflow: "hidden", position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{ background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)", padding: "18px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <i className="fa fa-whatsapp" style={{ fontSize: "24px", color: "#fff" }}></i>
                <h5 style={{ margin: 0, color: "#fff", fontWeight: 600 }}>Agregar Grupo de WhatsApp</h5>
              </div>
              <button
                type="button"
                style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", width: "32px", height: "32px", borderRadius: "50%", fontSize: "18px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                onClick={() => setModalAgregar(false)}
              >
                &times;
              </button>
            </div>

            {/* Body */}
            <div style={{ padding: "24px", flex: 1, overflowY: "auto" }}>
              <div style={{ marginBottom: "20px" }}>
                <label style={{ fontWeight: 500, marginBottom: "6px", display: "block", color: "#444" }}>
                  <i className="fa fa-road" style={{ marginRight: "6px", color: "#128C7E" }}></i>
                  Corredor
                </label>
                <Select
                  value={corredorModal}
                  onChange={(e) => setCorredorModal(e)}
                  options={corredores}
                  placeholder="Buscar corredor..."
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 99999 }),
                    control: base => ({ ...base, borderRadius: "8px", borderColor: "#ddd", boxShadow: "none", "&:hover": { borderColor: "#25D366" } }),
                    option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? "#25D366" : state.isFocused ? "#e8f5e9" : "#fff" }),
                  }}
                />
              </div>

              <div>
                <label style={{ fontWeight: 500, marginBottom: "6px", display: "block", color: "#444" }}>
                  <i className="fa fa-users" style={{ marginRight: "6px", color: "#128C7E" }}></i>
                  Grupo de WhatsApp
                </label>
                {grupoSeleccionado && (
                  <div style={{ backgroundColor: "#e8f5e9", border: "1px solid #25D366", borderRadius: "8px", padding: "8px 14px", marginBottom: "10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span style={{ fontWeight: 500, color: "#2e7d32" }}>
                      <i className="fa fa-check-circle" style={{ marginRight: "6px" }}></i>
                      {grupoSeleccionado.nombreGrupo}
                    </span>
                    <button
                      type="button"
                      style={{ background: "none", border: "none", color: "#999", cursor: "pointer", fontSize: "16px" }}
                      onClick={() => setGrupoSeleccionado(null)}
                    >
                      <i className="fa fa-times"></i>
                    </button>
                  </div>
                )}
                <TablePageable
                  lista={whatsappGrupos}
                  columnas={[
                    {
                      columna: "seleccionar",
                      label: "",
                      form: (e) => (
                        <div onClick={(ev) => ev.stopPropagation()}>
                          <input
                            type="radio"
                            name="grupoSeleccionado"
                            checked={grupoSeleccionado?.id === e.id}
                            onChange={() => setGrupoSeleccionado(e)}
                            style={{ accentColor: "#25D366", width: "16px", height: "16px", cursor: "pointer" }}
                          />
                        </div>
                      )
                    },
                    { columna: "nombreGrupo", label: "Grupo" },
                    { columna: "estatus", label: "Estatus",
                      form: (e) => (
                        <span style={{ padding: "2px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: 500, backgroundColor: e.estatus ? "#e8f5e9" : "#fce4ec", color: e.estatus ? "#2e7d32" : "#c62828" }}>
                          {e.estatus ? "Activo" : "Inactivo"}
                        </span>
                      )
                    },
                    { columna: "fecha", label: "Fecha" },
                  ]}
                  id="id"
                  selected={(e) => setGrupoSeleccionado(e)}
                  pageSize={5}
                />
              </div>
            </div>

            {/* Footer */}
            <div style={{ borderTop: "1px solid #eee", padding: "16px 24px", display: "flex", justifyContent: "flex-end", gap: "10px", backgroundColor: "#fafafa" }}>
              <button
                type="button"
                className="btn btn-sm"
                style={{ padding: "8px 20px", borderRadius: "8px", border: "1px solid #ddd", backgroundColor: "#fff", color: "#555", fontWeight: 500 }}
                onClick={() => setModalAgregar(false)}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-sm"
                style={{ padding: "8px 20px", borderRadius: "8px", border: "none", background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)", color: "#fff", fontWeight: 500, opacity: (!grupoSeleccionado || corredorModal.value === 0) ? 0.5 : 1, cursor: (!grupoSeleccionado || corredorModal.value === 0) ? "not-allowed" : "pointer" }}
                onClick={guardarNuevoGrupo}
                disabled={!grupoSeleccionado || corredorModal.value === 0}
              >
                <i className="fa fa-save" style={{ marginRight: "6px" }}></i>
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
          
  );
}
export default WhatsAppGruposClientesCorredores;
